import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbComponent } from '@shared/components/breadcrumb/breadcrumb.component';
import { Subscription } from 'rxjs';
import { FaqService } from './faq.service';
import { AccordionModule } from 'primeng/accordion';
import { FaqMoreInfoComponent } from './faq-more-info/faq-more-info.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SignalsService } from '@shared/services/signals/signals.service';
import { BreadcrumbService } from '@shared/components/breadcrumb/breadcrumb.service';
import { AppService } from 'app/app.service';
interface FaqGroups {
  general: any[];
  flights: any[];
  analyze: any[];
  search: any[];
  export: any[];
  admin: any[];
}

@Component({
    selector: 'app-faq',
    imports: [
        CommonModule,
        BreadcrumbComponent,
        AccordionModule,
    ],
    templateUrl: './faq.component.html',
    styleUrl: './faq.component.scss'
})


export class FaqComponent implements OnInit, OnDestroy {

  ref: DynamicDialogRef | undefined;

  path: string = '';
  routeSub?: Subscription;
  adminSub?: Subscription;

  faqGroups?: FaqGroups;
  faqGroupedQuestions?: any[];
  isAdmin: boolean = false;
  theme$ = this.appService.theme$;
  
  constructor(
    private route: ActivatedRoute,
    private faqService: FaqService,
    public dialogService: DialogService,
    private signalService: SignalsService,
    private breadcrumbService: BreadcrumbService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    const url = location.pathname;
    
    this.adminSub = this.signalService.isAdminRole$.subscribe( (isAdmin) => {
      this.isAdmin = isAdmin;
    });
    this.faqGroups = {
      general: this.faqService.getGeneralFAQ(),
      flights: this.faqService.getFlightsFAQ(),
      analyze: this.faqService.getAnalyzeFAQ(),
      search: this.faqService.getSearchFAQ(),
      export: this.faqService.getExportFAQ(),
      admin: this.faqService.getAdminFAQ()
    }
    this.routeSub = this.route.params.subscribe(params => {
      this.path = params['path'];
      if (this.path === 'general') {
        this.faqGroupedQuestions = this.faqGroups?.general;
        this.breadcrumbService.addToBreadcrumbs(url, 'General FAQ');
      } else if (this.path === 'flights') {
        this.faqGroupedQuestions = this.faqGroups?.flights;
        this.breadcrumbService.addToBreadcrumbs(url, 'Flights FAQ');
      } else if (this.path === 'analyze') {
        this.faqGroupedQuestions = this.faqGroups?.analyze;
        this.breadcrumbService.addToBreadcrumbs(url, 'Analyze FAQ');
      } else if (this.path === 'search') {
        this.faqGroupedQuestions = this.faqGroups?.search
        this.breadcrumbService.addToBreadcrumbs(url, 'Search FAQ');
      } else if (this.path === 'export') {
        this.faqGroupedQuestions = this.faqGroups?.export
        this.breadcrumbService.addToBreadcrumbs(url, 'Export FAQ');
      } else if (this.path === 'admin') {
        this.faqGroupedQuestions = this.faqGroups?.admin
        this.breadcrumbService.addToBreadcrumbs(url, 'Admin FAQ');
      }
    })
  }

  moreInfo(category: string, code: string) {
    const _category = this.faqGroups?.flights.filter(f => f.category === category);
    const questionData = _category?.map(c => {
      return c.faqs.filter((f: any) => f.code === code)[0];
    });
    this.ref = this.dialogService.open(FaqMoreInfoComponent, {
      data: {
        data: questionData
      },
      header: questionData?.[0].linkTitle,
      width: '50vw',
      modal: true,
      closable: true,
      dismissableMask: true,
      breakpoints: {
        '960px': '75vw',
        '640px': '90vw'
      },
    });
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.adminSub?.unsubscribe();
  }

  faqAccordion = {
    header: {
      color: '{text.color}',
      padding: '0.75rem 1rem',
      fontWeight: '400'
    },
    content: {
      background: 'transparent',
      padding: '0'
    },
    colorScheme: {
      light: {
        header: {
          background: '{surface.0}',
          hoverBackground: '{surface.0}',
          activeBackground: '{surface.0}',
          activeHoverBackground: '{surface.0}',
        }
      },
      dark: {
        header: {
          background: '{surface.50}',
          hoverBackground: '{surface.50}',
          activeBackground: '{surface.50}',
          activeHoverBackground: '{surface.50}',
        }
      }
    }
  }
}
